import { Zap } from "lucide-react";

function DailyLimitBanner({
    currentDuration,
}) {

    return (

        <div style={styles.banner}>

            <div style={styles.left}>

                <div style={styles.iconWrapper}>
                    <Zap
                        size={18}
                        color="#00d9f5"
                    />
                </div>

                <span style={styles.text}>
                    Max 2 hours per day
                    (all sports combined)
                </span>

            </div>

            <div style={styles.right}>

                <span style={styles.label}>
                    Today's usage:
                </span>

                <span
                    style={{
                        ...styles.value,
                        color:
                            currentDuration >= 2
                                ? "#ff6b6b"
                                : "#00f5a0",
                    }}
                >
                    {currentDuration}/2 hrs
                </span>

            </div>

        </div>
    );
}

const styles = {

    banner: {

        background:
            "rgba(5, 15, 30, 0.88)",

        backdropFilter:
            "blur(14px)",

        border:
            "1px solid rgba(0,217,245,0.22)",

        borderRadius: "18px",

        padding: "18px 22px",

        display: "flex",

        justifyContent: "space-between",

        alignItems: "center",

        marginBottom: "28px",

        boxShadow:
            "0 10px 30px rgba(0,0,0,0.35)",
    },

    left: {

        display: "flex",

        alignItems: "center",

        gap: "14px",
    },

    iconWrapper: {

        width: "38px",

        height: "38px",

        borderRadius: "12px",

        background:
            "rgba(0,217,245,0.12)",

        display: "flex",

        justifyContent: "center",

        alignItems: "center",

        border:
            "1px solid rgba(0,217,245,0.18)",
    },

    text: {

        color: "#fff",

        fontSize: "15px",

        fontWeight: "500",
    },

    right: {

        display: "flex",

        alignItems: "center",

        gap: "8px",
    },

    label: {

        color: "#9ca3af",

        fontSize: "14px",
    },

    value: {

        fontWeight: "bold",

        fontSize: "16px",
    },
};

export default DailyLimitBanner;